<script setup lang="ts">
import { h } from 'vue'

const emit = defineEmits<{
    (e: 'toggle', value: boolean): void
}>()
const { t } = useI18n()

const IconBurger = defineComponent({
    name: 'IconBurger',
    inheritAttrs: false,
    setup(_, { attrs }) {
        return () =>
            h(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 24', ...attrs },
                [
                    h('path', { fill: '#3D0703', d: 'M23.8881 2.83189H1.60987C1.08055 2.83189 0.655762 2.39655 0.655762 1.8618C0.655762 1.32706 1.08393 0.891724 1.60987 0.891724H23.8881C24.4174 0.891724 24.8422 1.32706 24.8422 1.8618C24.8422 2.39655 24.4141 2.83189 23.8881 2.83189Z' }),
                    h('path', { fill: '#3D0703', d: 'M23.8881 9.78013H1.60987C1.08055 9.78013 0.655762 9.34479 0.655762 8.81005C0.655762 8.2753 1.08393 7.83997 1.60987 7.83997H23.8881C24.4174 7.83997 24.8422 8.2753 24.8422 8.81005C24.8422 9.34479 24.4141 9.78013 23.8881 9.78013Z' }),
                    h('path', { fill: '#3D0703', d: 'M23.8881 16.7284H1.60987C1.08055 16.7284 0.655762 16.293 0.655762 15.7583C0.655762 15.2235 1.08393 14.7882 1.60987 14.7882H23.8881C24.4174 14.7882 24.8422 15.2235 24.8422 15.7583C24.8422 16.293 24.4141 16.7284 23.8881 16.7284Z' }),
                    h('path', { fill: '#3D0703', d: 'M23.8881 23.6732H1.60987C1.08055 23.6732 0.655762 23.2379 0.655762 22.7031C0.655762 22.1684 1.08393 21.733 1.60987 21.733H23.8881C24.4174 21.733 24.8422 22.1684 24.8422 22.7031C24.8422 23.2379 24.4141 23.6732 23.8881 23.6732Z' }),
                ]
            )
    }
})

const handleClick = () => {
    emit('toggle', true)
}

</script>

<template>
    <UButton class="bg-transparent p-0 hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden" :aria-label="t('header.menuItems.openBurgerMenu')" @click="handleClick">
        <UIcon :name="IconBurger" class="h-[24px] lg:h-[30px] w-auto" />
    </UButton>
</template>

<style scoped>

</style>
